import React from 'react';
import Collapsible from 'react-collapsible';
import './AuthorInfo.css';  // using the same css as the about page for now

const FAQ = () => (
  <section id="author-info" className="author-info">
    <div className="author-info_content">
      <div className="author-info_full_width">
        {/* <h3 className="section_title">Frequently Asked Questions...</h3> */}
        {/* replace the above with a graphic / cool font...? */}
        <img src="images/faq.png" />
        <p className="body_text">
          <Collapsible trigger=<strong> Q: “Reading is the worst! When will the audiobook be out?" </strong> >
            <p>A: The audiobook for Children of Nemia is <a href="https://amazon.com/dp/B0GRCVCJ14" target="blank">available on Audible</a></p>
          </Collapsible>

          <Collapsible trigger=<strong> Q: “English is just awful! When will the book be available in [insert language here]?" </strong> >
            <p>A: As of this writing, my works are available in English only and there are no official plans to release translations. I am, however,
              always eager to make new connections, and always looking for opportunities to extend the reach of these stories. Any news along these lines will be in the newsletter.</p>
          </Collapsible>

          <Collapsible trigger=<strong> Q: “How much of that AI do you use for your books?" </strong> >
            <p>A: I do not use generative AI at any stage of my writing process, and all of the artwork I commission is made by 100% organic human beings.</p>
          </Collapsible>

          <Collapsible trigger=<strong> Q: “I want to play D&D! Will you run a game for me and my friends?” </strong> >
            <p>A: Based on my availability, I can't guarantee this is something that will happen any time soon-but if you're
            interested in meeting new people that love tabletop RPGs, I highly recommend you drop into the <a href="https://discord.gg/DfyfVfcgtV" target="blank">Discord Server</a>.
            Social spaces like these are full of opportunities to make connections, and I made this one just for you!</p>
          </Collapsible>

          <Collapsible trigger=<strong> Q: “Writing is hard! Will you help me publish my book?” </strong> >
            <p>A: To inquire about beta reading, editing, or book coaching for fantasy and science fiction, please send a short description of your
              project to <a href="mailto:someone@example.com">information@michaelgoe.com</a>. While I try to answer all emails, please know that I have a very limited
              capacity to engage with individuals at the level they deserve as passionate writers.</p>

            <p>Before reaching out to any professional editor, take the time to familiarize yourself with industry standard rates for hiring these services.
              A great resource for this can be found online at the <a href="https://www.the-efa.org/rates/" target="blank">Editorial Freelancers Association website</a>.</p>

            <p>If you're not ready to engage with an editor yet, you can find excellent resources for new writers
              on the <a href="https://www.sfwa.org/" target="blank">SFWA website</a>.</p>

            <p>Last but not least, remember that community is essential to quality writing; make us a part of yours by
              joining our <a href="https://discord.gg/DfyfVfcgtV" target="blank">Official Discord Server</a>.</p>
          </Collapsible>
        </p>
      </div>
    </div>
  </section>
);

export default FAQ;
